<template>
  <!-- <div v-if="cloaked" class="row">
    <div style="margin: 300px auto; width: 145px">
      <img src="@/assets/loading.gif" />
    </div>
  </div> -->
  <!-- <div v-else>-->
  <div>
    <navbar :appconfig="appconfig"></navbar>
    <div v-cloak>
      <router-view />
    </div>
    <footer-panel></footer-panel>
  </div>
</template>

<script>
import FooterPanel from '@/components/app/Footer';
import Navbar from '@/components/app/Navbar';
import { AppConfig } from '@/config/config';
import { mapGetters } from 'vuex';


export default {
  components: {
    Navbar,
    FooterPanel,
  },
  computed: {
    ...mapGetters(['cloaked', 'current_user', 'isAuthenticated']),
  },
  data() {
    return {
      backdropStyle:
        'background: url("/images/login-backdrop.jpg") no-repeat center center fixed; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;',
      appconfig: {
        title: AppConfig.title,
      },
    };
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        if (this.$route.fullPath !== '/cleartoken') {
          if (this.current_user) {
            // const matchingRoute = this.$route.fullPath.match(
            //   /^(\/slack\/|\/reports\/|\/companies\)/
            // );
            const matchingRoute = this.$route.fullPath.match(
            /^(\/slack\/|\/reports\/|\/companies\/)/,
          );
            // console.log('matchingRoute');
            // console.dir(matchingRoute);
            if (matchingRoute === null || matchingRoute.length < 1) {
              this.$router.push('/reports/create');
            }
          }
        }
      }
    },
  },
  beforeCreate() {
    // Nuclear bomb style clear down of access tokens and other data
    // Should be a one shot deal but if its needed again
    // just add another token_delete entry in localStorage

    if (!localStorage.getItem('token_delete_20240507')) {
      // console.log('deleting');
      localStorage.removeItem('access_token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
      localStorage.setItem('token_delete_20240507', true);
      this.$router.push('/');
    } else {
      // console.log('skip delete');
    }
  },
};
</script>

<style>
/*needs updating*/
@import url('https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,800,900');

html {
  position: relative;
  min-height: 100%;
  font-size: 0.8rem;
}

body {
  font-family: 'Muli', sans-serif;
  font-weight: 400;
  background-color: #f5f5ff;
}

.body-container {
  padding-top: 76px;
  padding-bottom: 140px;
}

/* .content-area{
  margin-top: 100px;
} */

/* .information-page {
    margin-top: 100px;
    min-height: calc(100vh - 235px);
} */

.adminBackdrop {
  background: none;
  background-color: #fbd38d; /* Tailwind CSS v1.x orange-200, 'cozz I izz Dutch! */
}

.defaultBackdrop {
  background: none;
  background-color: #f5f5ff;
}

.loginBackdrop {
  background: url('/images/login-backdrop.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.errorBackdrop {
  background: url('/images/error-backdrop.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

/*-------------------------------------*/
/*---Responsive Elements---------------*/
/*-------------------------------------*/

#sectionBreak {
  margin-top: 97px;
  margin-left: -50px;
  border-bottom: 2px solid #ddd;
  margin-bottom: 97px;
  margin-right: -50px;
}

/* ------------- */
/* Wells */
/* ------------- */
.well-positive {
  background-color: #cce6d5;
  border-color: #229954;
  padding-top: 0px;
  padding-bottom: 0px;
}

.well-neutral {
  background-color: #d5d8dc;
  border-color: #566573;
  padding-top: 0px;
  padding-bottom: 0px;
}

.well-negative {
  background-color: #eecccb;
  border-color: #c0392b;
  padding-top: 0px;
  padding-bottom: 0px;
}

.well p {
  color: #000;
  font-size: 1rem;
}

.well i {
  font-weight: 900;
  font-size: 2.488rem;
  color: #000;
}

.well h4 {
  font-weight: 900;
  font-size: 1.44rem;
  color: #000 !important;
}

.well-positive h4 {
  font-weight: 900;
  font-size: 1.44rem;
  color: #229954 !important;
}

.well-negative h4 {
  font-weight: 900;
  font-size: 1.44rem;
  color: #c0392b !important;
}

.well-positive i {
  font-weight: 900;
  font-size: 2.488rem;
  color: #229954;
}

.well-negative i {
  font-weight: 900;
  font-size: 2.488rem;
  color: #c0392b;
}

/* ------------- */
/* ------------- */
/* ------------- */

/* ------------- */
/* Report Header */
/* ------------- */

.reportHeader h1 {
  color: #003352;
  font-size: 2.488rem;
  font-weight: 200;
  text-transform: uppercase;
}

.reportHeader h6 {
  color: #003352;
  font-weight: 900;
  font-size: 1rem;
}

.reportHeader hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #1a75cf;
  margin: 1em 0;
  padding: 0;
}

/* ------------- */
/* ------------- */
/* ------------- */

/* -------------- */
/* Report Section */
/* -------------- */

.reportSection h3 {
  font-weight: 200;
  color: #1a75cf;
  font-size: 2.074rem;
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-left: -20px;
  border-left: 3px solid;
  padding-left: 20px;
}

/* ------------- */
/* ------------- */
/* ------------- */

/* -------------- */
/* Summary Panels */
/* -------------- */

.panel-heading .accordion-toggle:after {
  font-family: 'Glyphicons Halflings';
  content: '\e114';
  float: right;
  color: grey;
}

.panel-heading .accordion-toggle.collapsed:after {
  content: '\e080';
}

.summaryPanel .clickable {
  cursor: pointer;
}

.summaryPanel .panel-heading span {
  font-size: 15px;
}

.summaryPanel.row {
  margin-top: 40px;
  padding: 0 10px;
}

.summaryPanel .table-striped {
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.summaryPanel .table-striped .totalRow {
  background-color: #e6f3f7;

  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
}

.summaryPanel .table-striped .totalRow td {
  font-weight: 900;
}

.summaryPanel .table-striped .spaceRow {
  background-color: #fff;
}

.summaryPanel .table-striped .redRAG {
  border-left-style: solid;
  border-left-width: 20px;
  border-left-color: #c0392b;
  font-size: 1rem;
  color: #000;
}

.summaryPanel .table-striped .amberRAG {
  border-left-style: solid;
  border-left-width: 20px;
  border-left-color: #ffbf00;
  /* font-size: 12px; */
  color: #000;
}

.summaryPanel .table-striped .greenRAG {
  border-left-style: solid;
  border-left-width: 20px;
  border-left-color: #229954;
  /* font-size: 1rem; */
  color: #000;
}

.summaryPanel .table-striped .blackRAG {
  border-left-style: solid;
  border-left-width: 20px;
  border-left-color: #000000;
  font-size: 1rem;
  color: #000;
}

.summaryPanel .table-striped .neutralRAG {
  border-left-style: solid;
  border-left-width: 20px;
  border-left-color: #efefef;
  font-size: 1rem;
  color: #000;
}

.summaryPanel h1 {
  padding: 10px;
  color: #1a75cf;
  font-size: 50px;
  vertical-align: middle;
}

.summaryPanel .panel-heading {
  font-size: 1rem;
}

.summaryPanel p {
  font-size: 1rem;
}

.summaryPanel h4 {
  font-weight: 900;
  font-size: 1.2rem;
  color: #1a75cf;
}

.summaryPanel h5 {
  font-weight: 400;
  font-size: 1.44rem;
  color: #003352;
}

.summaryPanel h6 {
  font-weight: 400;
  font-size: 1.2rem;
  color: #003352;
}

.summaryPanel h7 {
  color: #1a75cf;
  font-weight: 900;
  font-size: 1rem;
}

.summaryPanel th > i {
  font-weight: 400;
  font-size: 200%;
  color: #003352;
}

.summaryPanel thead {
  background-color: #fff;
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.summaryPanel th {
  color: #003352;
  font-weight: 900;
  font-size: 1rem;
}

.summaryPanel td {
  color: #2f4f4f;
  font-weight: 400;
  font-size: 1rem;
}

.summaryPanel strong {
  font-weight: 900;
}

.summaryPanel a {
  color: #1a75cf;
  text-decoration: none;
}

.summaryPanel a:hover {
  color: #9ec9e3;
  text-decoration: none;
}

/* ----- */
/* Diffs */
/* ----- */

th.diff {
  font-weight: 400;
  text-align: center;
}

.diff {
  color: black;
  padding-left: 5px;
  padding-right: 5px;
}

.diff-no-align {
  color: black;
}

.diff > .diff-header-row {
  margin-bottom: 0.25rem;
  border-bottom: 1px solid #aaaaaa;
}

.diff-new {
  background-color: #a5ffa5;
}

.diff-old {
  background-color: #fba1a1;
}

.diff-same {
  background-color: #c3c3c3;
}

/* ----------------- */
/* Buttons           */
/* ----------------- */

.btn-companiesSearch {
  width: 89.5333px;
}

.btn-recentReports {
  width: 94.6333px;
}

.btn-runReport {
  background-color: #fff;
  border-style: solid;
  border-width: thin;
  border-color: #1a9134;
  color: #1a9134;
  text-transform: uppercase;
  font-size: 0.833rem;
  border-radius: 0;
  font-weight: 400;
}

.btn-runReport:hover {
  color: #fff !important;
  background-color: #1a9134;
}

.btn-viewReport {
  background-color: #fff;
  border-style: solid;
  border-width: thin;
  border-color: #1a75cf !important;
  color: #1a75cf !important;
  text-transform: uppercase;
  font-size: 0.833rem;
  border-radius: 0;
  font-weight: 400;
}

.btn-viewReport:hover {
  color: #fff !important;
  background-color: #1a75cf !important;
}

/* ----------------- */
/* ----------------- */
/* ----------------- */

/* ------------- */
/* Result Labels */
/* ------------- */

.label-positive {
  background-color: #229954;
  border-style: solid;
  border-width: thin;
  border-color: #000000;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 0.833rem;
}

.label-neutral {
  background-color: #566573;
  border-style: solid;
  border-width: thin;
  border-color: #000000;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 0.833rem;
}

.label-negative {
  background-color: #c0392b;
  border-style: solid;
  border-width: thin;
  border-color: #000000;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 0.833rem;
}

.label-liquidated {
  background-color: #fa9c9c;
  border-style: solid;
  border-width: thin;
  border-color: #fa9c9c;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 0.833rem;
}

.label-amber {
  background-color: #ffbf00;
  border-style: solid;
  border-width: thin;
  border-color: #000000;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 0.833rem;
}

/* ------------- */
/* ------------- */
/* ------------- */

/*
.navbar-default.reportNavigation {
  background-color: #666666;
  margin-top: -20px;
  padding-left: 65px;
  min-height: 75px;
}

.navbar-default.reportNavigation > .open {
  padding-left: 0px !important;
}

.navbar-default.reportNavigation .navbar-nav > li > a:hover {
  color: #ccc;
}
*/

/* search navigation */
/* .navbar-default.searchNavigation {
    padding-left: 65px;
    min-height: 75px;

    text-align: center;
    position: relative;
    top: 50%;
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

.navbar-default.searchNavigation>.open {
padding-left: 0px!important;

}

.navbar-default.searchNavigation .navbar-nav>li>a:hover {
  color: #ccc;
}

.navbar-default.searchNavigation label {
    font-weight: 400;
    font-size: 1rem;
    text-transform: uppercase;
}

.btn-navigationSearch{
background-color: #fff;
border-style: solid;
border-width: thin;
border-color:  #1a75cf;
color:  #1a75cf;
text-transform: uppercase;
font-size: 0.833rem;
border-radius: 0;
font-weight: 400;
}

.btn-navigationSearch:hover{
color: #fff !important;
background-color:  #1a75cf;
}
 */

/* ------------ */
/* Login page   */
/* ------------ */

.loginPanel p {
  font-size: 1rem;
}

.loginPanel .panel-default {
  opacity: 0.95;
  margin-top: 10px;
  border-color: #1a75cf;
}

.loginPanel .form-group.last {
  margin-bottom: 0px;
}

.loginPanel h4 {
  font-weight: 900;
  font-size: 1.44rem;
  color: #1a75cf;
}

.loginPanel a {
  color: #1a75cf;
  text-decoration: none;
}

.loginPanel a:hover {
  color: #9ec9e3;
  text-decoration: none;
}

.absolute-center {
  margin: auto;
  position: absolute;
  top: -190px;
  left: 0;
  bottom: 0;
  right: 0;
}

.absolute-center.is-Responsive {
  width: 50%;
  height: 50%;
  min-width: 350px;
  max-width: 800px;
}

.hse-warning {
  color: #e0741c;
  font-size: 120%;
}

.subtext {
  font-size: 12px;
}

.unread-alert {
  font-weight: bold;
}

/* #informationArea{
    margin-top: 110px;
    margin-bottom: 50px;
}

#informationArea h3 {
font-weight: 200;
color: #1a75cf;
font-size: 2.074rem;
text-transform: uppercase;
margin-bottom: 20px;
margin-left: -20px;
border-left: 3px solid;
padding-left: 20px;
} */

/*search*/

/* .no-data {
  color: #aaa;
}

.invalid-tooltip {
  color: #e47a3d;
}

@media screen and (min-width: 992px) {
    html{
        font-size: 14px;
    }

    #reportArea {
    margin-top: 165px;
    }

    #sectionSpace {
    height: 50px;
    }

    .reportNavigation ul{
    padding-left: 205px;
    }
}

@media screen and (max-width: 992px) {
    html{
        font-size: 12px;
    }

    #reportArea {
    margin-top: 165px;
    }

    .reportNavigation ul{
    padding-left: 205px;
    }
  }

@media screen and (max-width: 767px) {
    html{
        font-size: 10px;
    }

    #reportArea {
    margin-top: 165px;
    }

    .reportNavigation ul{
    padding-left: 0px;
    }
  } */

.mr-2 {
  margin-right: 0.5rem;
}
</style>
